import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getAuthToken } from "../../utils/auth";
import { handleApiError } from "../handleApiError";

const API_URL = process.env.REACT_APP_API_URL;

export const toggleLike = createAsyncThunk(
  "like/toggle",
  async (postId, { rejectWithValue }) => {
    try {
      // console.log(postId);
      const token = getAuthToken();
      const res = await axios.patch(
        `${API_URL}/like/${postId}`,
        {},
        { headers: { Authorization: `${token}` } },
      );
      // console.log(res);
      return res.data.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getMyLikes = createAsyncThunk(
  "like/getMy",
  async (_, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const res = await axios.get(`${API_URL}/like`, {
        headers: { Authorization: `${token}` },
      });
      return res.data.data || [];
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
